import AppRoute from "../src/route/AppRoute";

function App() {
  return <AppRoute />;
}

export default App;